import placeholder from '@assets/placeholder.png';
import { Skeleton } from '@mui/material';
import { clsx } from 'clsx';
import React, { useCallback, useState } from 'react';

type VictronImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

export const VictronImage = ({ className, onLoad, onError, ...otherProps }: VictronImageProps) => {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    const handleLoaded: React.ReactEventHandler<HTMLImageElement> = useCallback(
        (e) => {
            if (onLoad) onLoad(e);
            setIsLoading(false);
        },
        [onLoad]
    );
    const handleError: React.ReactEventHandler<HTMLImageElement> = useCallback(
        (e) => {
            if (onError) onError(e);
            setError(true);
        },
        [onError]
    );

    return (
        <>
            <Skeleton hidden={!isLoading} variant="rounded" className={clsx(className, { '!h-0': !isLoading })} />
            <img
                onLoad={handleLoaded}
                onError={handleError}
                {...otherProps}
                src={error ? placeholder : otherProps.src || placeholder}
                className={clsx('bg-blog-neutral-300', { hidden: isLoading }, className)}
            />
        </>
    );
};
